var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paging" }, [
    _c(
      "ul",
      [
        _c("li", { staticClass: "paging-btn" }, [
          _c("img", {
            attrs: { src: require("./images/left.png") },
            on: {
              click: function($event) {
                _vm.prvePage(_vm.curIndex)
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm._l(_vm.indexs, function(index) {
          return _c("li", { class: { active: _vm.curIndex == index } }, [
            _c(
              "a",
              {
                staticClass: "paging-item",
                on: {
                  click: function($event) {
                    _vm.btnClick(index)
                  }
                }
              },
              [_vm._v(_vm._s(index < 1 ? "..." : index))]
            )
          ])
        }),
        _vm._v(" "),
        _c("li", { staticClass: "paging-btn" }, [
          _c("img", {
            staticStyle: { float: "right" },
            attrs: { src: require("./images/right.png") },
            on: {
              click: function($event) {
                _vm.nextPage(_vm.curIndex)
              }
            }
          })
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54622c8a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54622c8a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/commonPagination/commonPagination.vue
// module id = 620
// module chunks = 1